/* ==============================================================
   ARQUIVO DE SCRIPTS CUSTOMIZADOS (THEME MODIFICATIONS)
   ============================================================== */

document.addEventListener("DOMContentLoaded", function() {

  /* ------------------------------------------------------------
     1. ROBÔ RESTAURADOR DO BOTÃO "ADD +" (PÁGINA DE COLEÇÕES)
     ------------------------------------------------------------ */
  var restoreButtons = setInterval(function() {
    var hijackedWidgets = document.querySelectorAll('#product-grid .sealsubs-target-element.sls-homepage-automatic');
    
    if (hijackedWidgets.length > 0) {
      hijackedWidgets.forEach(function(widget) {
        var hasActiveSubscription = widget.querySelector('.sls-option-container');
        
        if (hasActiveSubscription) {
          var cardContent = widget.closest('.card__content--alternative');
          if (!cardContent) return;

          var rightColumn = cardContent.querySelector('.card__alternative-right');
          if (rightColumn && !rightColumn.querySelector('.custom-sub-btn')) {
            var titleLink = cardContent.querySelector('.card__alternative-title-link');
            var productUrl = titleLink ? titleLink.getAttribute('href') : '';

            if (productUrl) {
              rightColumn.innerHTML = `
                <a href="${productUrl}" class="custom-sub-btn card__alternative-button btn btn-primary" style="display: flex; justify-content: center; align-items: center; text-decoration: none; cursor: pointer; width: 100%;">
                  <span>Add +</span>
                </a>
              `;
            }
          }
        }
      });
    }
  }, 100);

  // Desliga o robô das coleções após 7 segundos
  setTimeout(function() { clearInterval(restoreButtons); }, 7000);


  /* ------------------------------------------------------------
     2. PLAYER DE VÍDEO MINIMALISTA (ÍCONE PREENCHIDO)
     ------------------------------------------------------------ */
  var customVideos = document.querySelectorAll('.custom-video-accordion__video');

  customVideos.forEach(function(video) {
    // Tira os controles nativos
    video.removeAttribute('controls');
    video.style.cursor = 'pointer';

    // Cria o botão central
    var playBtnContainer = document.createElement('div');
    playBtnContainer.className = 'custom-play-btn-overlay';
    // ALTERAÇÃO AQUI: fill="currentColor" e remoção do stroke
    playBtnContainer.innerHTML = `
      <svg viewBox="0 0 24 24" fill="currentColor" stroke="none" class="play-icon">
        <polygon points="5 3 19 12 5 21 5 3"></polygon>
      </svg>
    `;

    // Injeta na tela
    video.parentNode.insertBefore(playBtnContainer, video);

    // Função de Play/Pause
    function togglePlay() {
      if (video.paused) {
        video.play();
        playBtnContainer.classList.add('is-playing');
      } else {
        video.pause();
        playBtnContainer.classList.remove('is-playing');
      }
    }

    // Vincula o clique
    video.addEventListener('click', togglePlay);
    playBtnContainer.addEventListener('click', togglePlay);
    
    video.addEventListener('ended', function() {
      playBtnContainer.classList.remove('is-playing');
    });
  });

});